import React from 'react';

import autobind from "autobind-decorator";
import { connect } from "react-redux";
import classes from "./styles.module.css";
import { StepsTab } from "./Components/StepsTab";
import { PureComponent, Serialize, Description, GroupBox } from "core/components";

import {
  Block,
  Button,
  CardContent,
  List,
  ListItem,
  Popover
} from "core/components/Framework7";
import TimeTableColumn from './TimeTableComponents/TimeTableColumn';


class TimeTableStep extends PureComponent {
  constructor(props) {
    super(props);


    const view = this.$f7.views.get("#view-cart");
    this.router = view && view.router;

    this.state = {
      // value: null,
      // isOnlinePayment: false
    };
  }

  render() {
    // console.log("render  state online", this.state.isOnlinePayment);

    return (
      <div className={classes.container}>
        <StepsTab step={4} />
        <div className={classes.pagePadding}>
          <div className="" style={{ display: "flex", flexDirection: "row", padding: "2rem", height: "auto" }}>
            <TimeTableColumn />
            <TimeTableColumn />
            <TimeTableColumn />
            <TimeTableColumn />
            <TimeTableColumn />
            <TimeTableColumn />
            <TimeTableColumn />
          </div>
        </div>
        {/* <Button
          large
          fill
          icon="mdi-arrow-left"
          text={"تایید نهایی و پرداخت"}
          className={classes.nextButton}
          onClick={() => this.handleNextOnlinePayment()}
        />
        :
        <Button
          large
          fill
          icon="mdi-arrow-left"
          text={"ثبت نهایی"}
          className={classes.nextButton}
          onClick={() => this.handleNext()} /> */}
      </div>
    );
  }
}


export default connect(
  state => ({
    order: state.Order.order,
    gateway: state.Order.gateway,
    paymentResult: state.Order.paymentResult,
    price: state.Order.price,
    user: state.General.user
  }),
  {
    // finalize,
    // finalizeOnline,
    // checkPaymentResult
  }
)(autobind(TimeTableStep));
